<template>
  <Row class="page3">
    <div
      v-if="loadingFlag"
      :style="{
        background: 'url(' + $images.background_bg + ')',
        backgroundSize: '100%',
      }"
      style="
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
      "
    ></div>
    <!-- 左三和左四 -->
    <svg class="line" v-show="showRight">
      <circle
        :cx="getLine2Start(point2, 'cx')"
        :cy="getLine2Start(point2, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <circle
        :cx="getLine2End(point2, 'cx')"
        :cy="getLine2End(point2, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <polyline :points="point2" stroke="white" stroke-width="1" fill="none" />
    </svg>
    <!-- 左1和左2 -->
    <svg class="line">
      <circle
        v-for="(item, index) in points1"
        :key="index + 'circle1start'"
        :cx="getLine1Start(item.data, 'cx')"
        :cy="getLine1Start(item.data, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <circle
        v-for="(item, index) in points1"
        :key="index + 'circle2start'"
        :cx="getLine1End(item.data, 'cx')"
        :cy="getLine1End(item.data, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <polyline
        v-for="(item, index) in points1"
        :key="index + 'line1'"
        :points="item.data"
        stroke="white"
        stroke-width="1"
        fill="none"
      />
    </svg>
    <!-- 左2和左3 -->
    <svg class="line" v-show="showRight">
      <circle
        v-for="(item, index) in points23"
        :key="index + 'circle3start'"
        :cx="getLine1Start(item, 'cx')"
        :cy="getLine1Start(item, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <circle
        v-for="(item, index) in points23"
        :key="index + 'circle3end'"
        :cx="getLine1End(item, 'cx')"
        :cy="getLine1End(item, 'cy')"
        r="5"
        fill="#BF9D63"
      />
      <polyline
        v-for="(item, index) in points23"
        :key="index + 'line2'"
        :points="item"
        stroke="white"
        stroke-width="1"
        fill="none"
      />
    </svg>
    <Col style="width: 24%; float: left">
      <div class="left animate__animated animate__rubberBand">
        <!-- <div class="bu" ref="node">BU1</div> -->
        <div
          ref="node"
          class="bu angle item activeOrange"
          :key="'item4'"
          style="min-width: 240px"
        >
          <div class="angleSon">
            <div class="line1">
              <div class="dot"></div>
              <div class="name" style="font-size: 1vw">{{ data1[0] }}</div>
            </div>
            <div
              class="line2"
              style="
                display: flex;
                align-content: center;
                justify-content: space-between;
              "
            >
              <div class="left">
                <div class="key" style="font-size: 0.8vw">KRI预警个数</div>
                <div class="value" style="font-size: 1.1vw">{{ data1[1] }}</div>
              </div>
              <div class="right">
                <div class="key" style="font-size: 0.8vw">最长持续天数</div>
                <div class="value" style="font-size: 1.1vw">{{ data1[2] }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
    <Col style="width: 26%; padding: 0 1%">
      <div class="leList overHeight">
        <div
          :ref="item.name"
          :class="item.active ? 'activeOrange' : ''"
          class="angle item animate__animated animate__jello"
          style="min-width: 140px; margin-left: 1vw"
          v-for="(item, index) in data2"
          :key="item.name"
          @click="getData3(item.name, index)"
        >
          <div class="angleSon">
            <div class="line1">
              <div class="dot"></div>
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="line2">
              <div class="left">
                <div class="key">KRI预警个数</div>
                <div class="value">{{ item.data.kri }}</div>
              </div>
              <div class="right">
                <div class="key">最长持续天数</div>
                <div class="value">{{ item.data.MAX_RISK_DATE_NUMBER }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
    <Col style="width: 25%; padding: 0 1%" v-show="showRight">
      <div class="leList thirdColumn overHeight" @scroll="test()">
        <div
          v-for="(item, index) in data3"
          :ref="item.name"
          :class="item.active ? 'activeOrange' : ''"
          class="angle item animate__animated animate__jello"
          style="min-width: 140px; margin-left: 1vw"
          @click="getData4(item.father, index)"
        >
          <div class="angleSon">
            <div
              class="line1"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div class="name" style="font-size: 1vw">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </Col>
    <Col style="width: 20%; float: right" v-show="showRight">
      <div class="rightList angle" ref="right" style="padding: 0">
        <div class="myWrap">
          <div class="myWrap2 overHeight">
            <div class="wrap" v-for="(item, index) in data4Arr">
              <div class="rightTitle">{{ item.name }}-{{ data4["板块"] }}</div>
              <div v-for="item2 in item.list">
                <div
                  v-for="(item3, index3) in item2"
                  @click="toSon(item2)"
                  class="item angle animate__animated animate__swing"
                >
                  <div class="angleSon">
                    <div class="line1">
                      <div class="dot"></div>
                      <div class="name">{{ index3 }}</div>
                    </div>
                    <div class="line2">
                      <div class="left">
                        <div class="key">KRI预警个数</div>
                        <div class="value">
                          {{ item3 && item3[0] && item3[0].kri }}
                        </div>
                      </div>
                      <div class="right">
                        <div class="key">最长持续天数</div>
                        <div class="value">
                          {{
                            item3 && item3[0] && item3[0].MAX_RISK_DATE_NUMBER
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
// import "animate.css";
import { mapActions } from "pinia";
import { useDataStore } from "@/store";
import {
  getChildrenList,
  getRiskDetailsByCompany4,
  getRiskIndicatorsByArea,
} from "../api";

export default {
  name: "page5",
  components: {},
  created() {
    setTimeout(() => {
      this.loadingFlag = false;
    }, 2000);
    this.data1 = this.$route.params.part.split("|");
    this.setBackurl("/PC/home_domesitc");
    this.setTitle("境内风险概览");
  },
  data() {
    return {
      showRight: true,
      nameList: [
        "上海冠生园食品有限公司",
        "上海冠生园天山食品有限公司",
        "上海冠生园蜂制品有限公司",
        "上海冠生园食品供销有限公司",
        "上海爱森食品加工有限公司",
        "上海爱森食品销售有限公司",
        "江苏淮安苏食肉品有限公司",
        "江苏省苏食肉品有限公司",
        "上海联豪食品有限公司",
        "上海联豪食品有限公司",
        "扬州市江都区品旺农牧科技有限公司",
        "高邮品旺农牧科技有限公司",
        "盐城光明生猪有限公司",
        "江苏梅林畜牧有限公司",
        "光明农牧科技有限公司上海崇明分公司",
        "贵州明春农牧科技有限公司",
        "河北众旺农牧科技有限公司",
        "上海五丰商务有限公司",
        "上海市食品进出口有限公司",
        "上海市食品进出口国际货运有限公司",
        "光明食品国际贸易（上海）有限公司",
        "南华国际发展有限公司",
        "上海良友新港储运有限公司",
      ],
      jkkj: "",
      loadingFlag: true,
      data1: [], //左1的数据
      data2: [], //左2的数据
      data3: [], //左3的数据
      data4: {}, //左4的数据
      data4Arr: [],
      isMain: true,
      points: "",
      point2: "",
      points1: [],
      points23: [],
      list1: [
        {
          name: "LE1",
          kri: 4,
          longday: 88,
        },
        {
          name: "LE2",
          kri: 2,
          longday: 72,
        },
        {
          name: "LE3",
          kri: 3,
          longday: 54,
        },
        {
          name: "LE4",
          kri: 1,
          longday: 59,
        },
        {
          name: "LE5",
          kri: 4,
          longday: 84,
        },
        {
          name: "LE6",
          kri: 3,
          longday: 82,
        },
      ],
      currentLine: "",
      list2: [
        {
          category: "核心风险",
          list: [
            {
              name: "流动风险",
              kri: 1,
              longday: 59,
            },
          ],
        },
        {
          category: "发展风险",
          list: [
            {
              name: "人力资源管理风险",
              kri: 1,
              longday: 59,
            },
            {
              name: "投资管理风险",
              kri: 1,
              longday: 59,
            },
          ],
        },
        {
          category: "运营风险",
          list: [
            {
              name: "原材料采购风险",
              kri: 1,
              longday: 59,
            },
            {
              name: "存货管理风险",
              kri: 1,
              longday: 59,
            },
          ],
        },
      ],
      list23: [
        {
          name: "上海梅林正广和（绵阳）有限公司",
          kri: 4,
          longday: 88,
        },
        {
          name: "上海梅林食品有限公司",
          kri: 2,
          longday: 72,
        },
        {
          name: "上海梅林正广和股份有限公司销售 分公司",
          kri: 3,
          longday: 54,
        },
        {
          name: "上海梅林罐头食品厂有限公司",
          kri: 1,
          longday: 59,
        },
        {
          name: "LE5",
          kri: 4,
          longday: 84,
        },
        {
          name: "LE6",
          kri: 3,
          longday: 82,
        },
      ],
    };
  },

  async mounted() {
    await this.getData2(this.data1[0]);
    if (
      !(this.data2[0].name == "梅林罐头" || this.data2[0].name == "鼎牛饲料")
    ) {
      this.$message.info("暂无数据");
      this.$nextTick(() => {
        this.getLine1();
      });
      return;
    }
    await this.getData3(this.data2[0].name);
    await this.getData4(this.data3[0].father, 0);

    this.$nextTick(() => {
      this.getLine1();
      this.getLine2new(this.data2[0].name, 0);
      this.getLine2(this.data3[0].name);
    });
    window.addEventListener("resize", this.getLine1);
    // window.addEventListener("resize", this.getLine2);
    // window.addEventListener("resize", this.getLine23);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getLine1);
    // window.removeEventListener("resize", this.getLine2);
    // window.removeEventListener("resize", this.getLine23);
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setBackurl"]),
    test() {},
    async getData3(name, index) {
      if (!(name == "梅林罐头" || name == "鼎牛饲料")) {
        this.$message.info("暂无数据");
        return;
      }
      const res = await getRiskDetailsByCompany4({
        companyName: name,
        topic: this.data1[0],
      });
      if (res.code == 200) {
        if (index != undefined && index > -1) {
          this.data2.forEach((item) => {
            item.active = false;
          });
          this.data2[index].active = true;
        }
        let flag = false;
        this.data3 = [];
        for (let i in res.data) {
          res.data[i].forEach((item) => {
            this.data3.push({
              name: item,
              father: i,
              active: flag ? false : true,
            });
          });
          flag = true;
        }
        this.$nextTick(() => {
          this.getData4(this.data3[0].father, 0);
          this.getLine2new(name, index);
          this.lightFather();
        });
      }
    },
    async getData4(name, index) {
      if (this.nameList.includes(name)) {
        this.$message.info("暂无数据");
        return;
      }

      // 监控口径
      this.jkkj = name;
      const res = await getRiskIndicatorsByArea({
        area: name,
        topic: this.data1[0],
      });
      if (res.code == 200) {
        let arr = [];
        for (let i in res.data) {
          if (i.indexOf("风险") > -1) {
            arr.push({
              name: i,
              list: res.data[i],
            });
          }
        }
        this.data4 = res.data;
        this.data4Arr = arr;
        if (index != undefined && index > -1) {
          this.data3.forEach((item) => {
            item.active = false;
          });
          this.data3[index].active = true;
        }
        this.$nextTick(() => {
          this.getLine2(this.data3[index].name);
          this.lightFather();
        });
      }
    },
    lightFather() {
      let item = this.data3.find((item) => item.active == true);
      if (item) {
        let father = item.father;
        this.data3 = this.data3.map((item) => {
          return {
            ...item,
            active: item.father == father,
          };
        });
      }
    },
    async getData2(name) {
      const res = await getChildrenList({ param: name });
      if (res.code == 200) {
        let flag = false;
        for (let i in res.data) {
          this.data2.push({
            data: res.data[i],
            name: i,
            active: flag == false ? true : false,
          });
          flag = true;
        }
      }
    },
    choseList1(index) {
      this.list1.forEach((item) => {
        item.active = false;
      });
      this.list1[index].active = true;
      this.isMain = false;
    },
    choseMain() {
      this.isMain = true;
      this.list1.forEach((item) => {
        item.active = false;
      });
    },
    jump(page) {
      this.$router.push(page);
    },
    toSon(item) {
      let risk = Object.keys(item)[0];
      this.$router.push({
        path: "/PC/page/" + this.jkkj + "/" + risk + "?type=domestic",
      });
    },
    // 左边全部连线
    async getLine1() {
      const vw1 = document.body.clientWidth / 100;
      const node1 = this.$refs.node;
      let points1 = {};
      this.points1 = [];
      for (let i in this.data2) {
        let node = this.$refs[this.data2[i].name][0];
        const bbox1 = node1.getBoundingClientRect();
        const bbox2 = node.getBoundingClientRect();
        const x1 = bbox1.left + bbox1.width;
        const y1 = bbox1.top + bbox1.height / 2 - vw1 * 6;
        const x2 = bbox2.left;
        const y2 = bbox2.top + bbox2.height / 2 - vw1 * 6;
        points1[i] = `${x1},${y1} ${x1 + 40},${y1} ${
          x1 + 40
        },${y2} ${x2},${y2}`;
      }
      for (let i in points1) {
        this.points1.push({
          name: i,
          data: points1[i],
        });
      }
    },
    getLine1Start(point, type) {
      if (point) {
        if (type == "cx") {
          return point.split(" ")[0].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[0].split(",")[1];
        }
      }
    },
    getLine1End(point, type) {
      if (point && this.points1.length > 0) {
        let length = this.points1[0].data.split(" ").length;
        if (type == "cx") {
          return point.split(" ")[length - 1].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[length - 1].split(",")[1];
        }
      }
    },

    getLine2Start(point, type) {
      if (point) {
        if (type == "cx") {
          return point.split(" ")[0].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[0].split(",")[1];
        }
      }
    },
    getLine2End(point, type) {
      if (point && this.points1.length > 0) {
        let length = this.points1[0].data.split(" ").length;
        if (type == "cx") {
          return point.split(" ")[length - 1].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[length - 1].split(",")[1];
        }
      }
    },

    //左三和左四连线
    getLine23() {
      const vw1 = document.body.clientWidth / 100;
      const node1 = this.$refs["center1"][0];
      this.list23.forEach((item, i) => {
        let node = this.$refs["center2" + (i + 1)][0];
        const bbox1 = node1.getBoundingClientRect();
        const bbox2 = node.getBoundingClientRect();
        const x1 = bbox1.left + bbox1.width;
        const y1 = bbox1.top + bbox1.height / 2 - vw1 * 6;
        const x2 = bbox2.left;
        const y2 = bbox2.top + bbox2.height / 2 - vw1 * 6;
        this.points23[i] = `${x1},${y1} ${x1 + 40},${y1} ${
          x1 + 40
        },${y2} ${x2},${y2}`;
        this.points23 = [...this.points23];
      });
    },
    getLine23Start(point, type) {
      if (point) {
        if (type == "cx") {
          return point.split(" ")[0].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[0].split(",")[1];
        }
      }
    },
    getLine23End(point, type) {
      if (point) {
        let length = this.points23[0].split(" ").length;
        if (type == "cx") {
          return point.split(" ")[length - 1].split(",")[0];
        }
        if (type == "cy") {
          return point.split(" ")[length - 1].split(",")[1];
        }
      }
    },
    // 点击左二变线
    async getLine2new(ref, index) {
      const vw1 = document.body.clientWidth / 100;
      //这里是左二选中的
      const node1 = this.$refs[ref][0];
      this.points23 = [];
      this.data3.forEach((item, i) => {
        let node = this.$refs[item.name][0];
        const bbox1 = node1.getBoundingClientRect();
        const bbox2 = node.getBoundingClientRect();
        const x1 = bbox1.left + bbox1.width;
        const y1 = bbox1.top + bbox1.height / 2 - vw1 * 6;
        const x2 = bbox2.left;
        const y2 = bbox2.top + bbox2.height / 2 - vw1 * 6;
        this.points23[i] = `${x1},${y1} ${x1 + 40},${y1} ${
          x1 + 40
        },${y2} ${x2},${y2}`;
        this.points23 = [...this.points23];
      });
    },
    // 3和4的连线 未开始
    async getLine3new(ref) {
      const vw1 = document.body.clientWidth / 100;
      const node1 = this.$refs[ref][0];
      this.points23 = [];
      this.data3.forEach((item, i) => {
        let node = this.$refs[item.name][0];
        const bbox1 = node1.getBoundingClientRect();
        const bbox2 = node.getBoundingClientRect();
        const x1 = bbox1.left + bbox1.width;
        const y1 = bbox1.top + bbox1.height / 2 - vw1 * 6;
        const x2 = bbox2.left;
        const y2 = bbox2.top + bbox2.height / 2 - vw1 * 6;
        this.points23[i] = `${x1},${y1} ${x1 + 40},${y1} ${
          x1 + 40
        },${y2} ${x2},${y2}`;
        this.points23 = [...this.points23];
      });
    },
    // 右边选中连线
    getLine2(ref) {
      const vw1 = document.body.clientWidth / 100;

      if (ref && typeof ref == "string") {
        this.currentLine = ref;
      }
      let node1 = this.$refs[this.currentLine][0];
      let node2 = this.$refs["right"];
      const bbox1 = node1.getBoundingClientRect();
      const bbox2 = node2.getBoundingClientRect();
      const x1 = bbox1.right;
      const y1 = bbox1.top + bbox1.height / 2 - vw1 * 6;
      const x2 = bbox2.left;
      const y2 = bbox2.top + bbox2.height / 2 - vw1 * 6;
      this.point2 = `${x1},${y1} ${x1 + 40},${y1} ${x1 + 40},${y2} ${x2},${y2}`;
    },
    updateLine() {
      const node1 = this.$refs.node;
      const node2 = this.$refs.node1;
      const bbox1 = node1.getBoundingClientRect();
      const bbox2 = node2.getBoundingClientRect();
      const x1 = bbox1.left + bbox1.width;
      const y1 = bbox1.top - bbox1.height / 2;
      const x2 = bbox2.left;
      const y2 = bbox2.top;
      this.points = `${x1},${y1} ${x1},${(y1 + y2) / 2} ${x2},${
        (y1 + y2) / 2
      } ${x2},${y2}`;
    },
  },
};
</script>

<style lang="less" scoped>
.myWrap2 {
  width: 100%;
  height: 100%;
  padding: 1vw;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
}
.myWrap {
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
}
.angle .angleSon {
  padding: 1vw !important;
}
.activeOrange {
  background: rgba(191, 157, 99, 0.3);
}
@keyframes draw-line {
  from {
    stroke-dasharray: 0 200;
  }
  to {
    stroke-dasharray: 200 0;
  }
}
.line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  stroke-dasharray: 0 200;
  animation: draw-line 1s forwards;
}
.leList {
  padding-left: 1.5vw;
  height: 100%;
  //   overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  .item {
    width: 18vw;
    height: 6vw;
    border: 1px solid #4d4a48;
    margin-bottom: 15px;
    cursor: pointer;
    .line1 {
      display: flex;
      align-items: center;
      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
      }
      .name {
        margin-left: 15px;
        color: #bf9d63;
        font-size: 20px;
        font-size: 1vw;
      }
    }
    .line2 {
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-top: 0.4vw;
      .left {
        display: flex;
        align-items: center;
        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
          font-size: 0.8vw;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
          font-size: 1.1vw;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
          font-size: 0.8vw;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
          font-size: 1.1vw;
        }
      }
    }
  }
}
.rightList {
  height: 100%;
  overflow-y: auto;
  background: rgba(87, 87, 87, 0.1);
  border: 1px solid #4d4a48;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  .wrap {
    .rightTitle {
      font-weight: 600;
      font-size: 20px;
      color: #bf9d63;
      margin-bottom: 15px;
    }
  }
  .item {
    width: 17vw;
    height: 6vw;
    border: 1px solid #4d4a48;
    margin-bottom: 15px;
    min-width: 140px;
    &:nth-child(even) {
      margin-right: 8%;
    }
    cursor: pointer;
    .line1 {
      display: flex;
      align-items: center;
      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
      }
      .name {
        margin-left: 15px;
        color: #bf9d63;
        font-size: 20px;
        font-size: 0.9vw;
      }
    }
    .line2 {
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-top: 0.2vw;
      .left {
        display: flex;
        align-items: center;
        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
          font-size: 0.7vw;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
          font-size: 1.1vw;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
          font-size: 0.8vw;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
          font-size: 1.1vw;
        }
      }
    }
  }
}
.left {
  height: 100%;
  display: flex;
  align-items: center;
  .bu {
    display: flex;
    flex-direction: column;
    width: 18vw;
    height: 6vw;
    border: 1px solid #4d4a48;
    .angleSon {
      display: flex;
      flex-direction: column;
    }
    // margin-top: auto;
    // margin-bottom: auto;
    // width: 40%;
    // height: 82px;
    // background: rgba(191, 157, 99, 0.3);
    // border: 1px solid #5f5443;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // font-weight: 600;
    // font-size: 20px;
    // color: #ffffff;
    .line1 {
      display: flex;
      align-items: center;
      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
      }
      .name {
        margin-left: 15px;
        color: #bf9d63;
        font-size: 0.8vw;
      }
    }
    .line2 {
      height: 40px;
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .key {
          font-size: 16px;
          color: #fff;
          opacity: 0.6;
        }
        .value {
          padding-left: 10px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          opacity: 0.8;
        }
      }
    }
  }
}
.center {
  .le {
  }
}
.right {
}
.page3 {
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   padding-top: 5%;
  padding-left: 3%;
  padding-right: 3%;
  //   background: #03044a;
  overflow: hidden;
  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }
  }

  .center-top {
    height: 60%;
  }

  .center-bottom {
    height: 40%;

    .bottom-radars {
      height: 55%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
</style>
